<template>
    <section>
        <SfeSidePanel    
            :is-modal-open="modalVisible"
            @close:modal="closeModal"
            :closeOnOverlayClick="closeOnClickOut"
            :closeOnEsc="closeSidePanelWithEscKey"
            :size="sidePanelSize"
            :position="sidePanelPosition"	
        >
            <template #title>
                <div class="d-flex align-items-center">
                    <div v-if="showHeaderIcon" class="mr-2">
                        <slot name="header-icon"></slot>
                    </div>
                    <div>
                        {{ title }}
                        <span class="d-block text-muted fw-400 fs-12">
                            {{ subTitle }}
                        </span>
                    </div>
                </div>
            </template>
            <template #description>
                {{ description }}
            </template>

            <template #body>
                <div>
                    <slot></slot>
                </div>
            </template>


            <template #footer v-if="showFooter">
                <slot name="footer"></slot>
            </template>

        </SfeSidePanel>
    </section>
</template>

<script>

export default {
    // This component has been registered globally and it can be used anywhre without being imported.
    name: 'SidePanelModal',
    emits: ['close:modal'],
    props: {
        sidePanelSize: {
            type: String,
            default: 'lg'
        },
        sidePanelPosition: {
            type: String,
            default: 'right'
        },
        showHeaderIcon: {
            type: Boolean,
            default: false 
        },
        showModal: {
            type: Boolean,
            default: false 
        },
        closeSidePanelWithEscKey: {
            type: Boolean,
            default: false 
        },

        closeOnClickOut: {
            type: Boolean,
            default: false 
        },

        showFooter: {
            type: Boolean,
            default: false 
        },

        title: {
            type: String,
            default: '' 
        },

        description: {
            type: String,
            default: '' 
        },
        subTitle: {
            type: String,
            default: '',
            description: 'In a situation where you have to pass an icon to the header, it\'s recommended to use this prop and not the description prop.'
        }
    },
    data() {
        return { 
            modalVisible: false,
        }
    },
    mounted() {
        this.modalVisible = this.showModal
    },
    watch: {
        showModal:{
            immediate: true,
            handler(newValue){
                this.modalVisible = newValue
            }
        },
    },
    computed: {
    },
    methods: {
        closeModal() {
            this.modalVisible = false
            this.$emit('lightbox:close');
        },
},
           
}
</script>

<style scoped>
    ::v-deep(.sfe-side-panel__body) {
        padding: 0 !important;
        height: 100%;
        max-height: 100vh;
    }
</style>